<div class="container">
    <div class="row">
        <div class="col-lg-12">
            <div class="text-center mt-sm-5 mb-4 text-dark">
                <div>
                    <a routerLink="" class="d-inline-block auth-logo">
                        <img src="assets/images/logo-dark.svg" alt="" height="40">
                    </a>
                </div>
                <p class="mt-3 fs-15 fw-medium">{{'MESSAGES.GET_YOUR_DETAILED_CAHSH' | translate}}</p>
            </div>
        </div>
    </div>
    <div class="row justify-content-center">
        <div class="col-lg-10">
            <div class="card">
                <div class="bg-soft-warning position-relative">
                    <div class="card-body p-5">
                        <div class="text-center">
                            <h3>Privacy &amp; Policy</h3>
                            <p class="mb-0 text-muted">Last update: 16 Sept, 2022</p>
                        </div>
                    </div>
                    <div class="shape">
                        <svg xmlns="http://www.w3.org/2000/svg" version="1.1" xmlns:xlink="http://www.w3.org/1999/xlink"
                            xmlns:svgjs="http://svgjs.com/svgjs" width="1440" height="60" preserveAspectRatio="none"
                            viewBox="0 0 1440 60">
                            <g mask="url(&quot;#SvgjsMask1001&quot;)" fill="none">
                                <path d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                                    style="fill: var(--vz-card-bg-custom);"></path>
                            </g>
                            <defs>
                                <mask id="SvgjsMask1001">
                                    <rect width="1440" height="60" fill="#ffffff"></rect>
                                </mask>
                            </defs>
                        </svg>
                    </div>
                </div>
                <div class="card-body p-4">
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Privacy Policy</h5>
                        <p class="text-muted">
                            The protection of your personal data is of utmost importance to us. As a
                            client using Deben (as defined below), we are committed to collecting and processing your
                            information in accordance with applicable laws and regulations. This Privacy Policy
                            describes the information we collect and process, how it may be used, with whom it may be
                            shared, and for what reasons.
                        </p>
                        <p class="text-muted">
                            This Privacy Policy is intended to be read in conjunction with our General Terms and
                            Conditions and your Client Agreement with us, to ensure that you are fully aware of how and
                            why we use your data. This Privacy Policy supplements any other notices and privacy policies
                            and is not intended to override them.
                        </p>
                        <p class="text-muted">
                            By using Deben, you are acknowledging and accepting the practices described in this Privacy
                            Policy. We will obtain your explicit consent before using your personal data for any purpose
                            other than what is stated in this Privacy Policy.
                        </p>
                        <p class="text-muted">
                            This Privacy Policy applies to you as a Client, as well as your authorized representatives
                            where applicable, and your use of Deben is subject to its terms.
                        </p>
                    </div>

                    <div>
                        <h5 class="text-decoration-underline fw-bold">Definitions:</h5>
                        <p class="text-dark">
                            In this Privacy Policy, the following terms have the following meanings:
                        </p>
                        <p class="text-muted">
                            API: means the Deben Application Programming Interface, which is used to access Deben
                            services if you transact through your own systems.
                        </p>
                        <p class="text-muted">
                            Site & App: means the Deben website and mobile app, which are used to access Deben services.
                        </p>
                        <p class="text-muted">
                            Deben: means the API and/or Site & App.
                        </p>
                        <p class="text-muted">
                            AOH: means Al Omla Al Hadesa for financial solutions (AOH) and any reference to "ourselves",
                            "we", "our" and "us" shall have the same meaning.
                        </p>
                        <p class="text-muted">
                            Client means any person who accesses Deben. Any reference to "you" and "your" shall include
                            the same meaning.
                        </p>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Who We Are:</h5>
                        <p class="text-muted">
                            AOH is the entity that collects, uses, and protects your personal data when you visit and
                            use Deben. We are committed to respecting your privacy and complying with applicable data
                            protection laws.
                        </p>
                        <p class="text-muted">
                            This Privacy Policy explains how we collect, use, and protect your personal data. Please
                            read it carefully to understand our practices.
                        </p>
                        <p class="text-muted">
                            If you have any questions about this Privacy Policy or our privacy practices, please contact
                            us through the channels provided on Deben.
                        </p>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Collection, Use, And Disclosure of Your Data:</h5>
                        <p class="text-dark">
                            We collect and use your personal data in accordance with applicable laws and regulations. We
                            may use your personal data for the following purposes:
                        </p>
                        <ul class="text-muted vstack gap-2">
                            <li>
                                To register, integrate, and manage your account on Deben;
                            </li>
                            <li>
                                To fulfill your requests made through Deben;
                            </li>
                            <li>
                                To provide you with our services (e.g., facilitating transactions, providing relevant
                                banking information);
                            </li>
                            <li>
                                To monitor the quality of our services;
                            </li>
                            <li>
                                To conduct fraud prevention, due diligence, anti-money laundering, and credit checks;
                            </li>
                            <li>
                                To perform research, analysis, studies, inquiries, and surveys on your use of Deben;
                            </li>
                            <li>
                                To enhance the functionality of Deben to better serve your needs;
                            </li>
                            <li>
                                To comply with legal, judicial, regulatory, security, or ethical requirements.
                            </li>
                        </ul>
                        <p class="text-black">
                            The personal data we collect may include, but is not limited to:
                        </p>
                        <ul class="text-muted vstack gap-2">
                            <li>
                                Name, commercial registration number, email, address, password, and other details
                                necessary to add to your account, such as identity and phone numbers;
                            </li>
                            <li>
                                Bank name, bank account number, order requester, order and response details (e.g.,
                                payment amount, date, beneficiary details, account balance, and transaction
                                details);
                            </li>
                            <li>
                                Your responses to our emails, phone calls, and SMS inquiries regarding the quality
                                of our service and your contact history with us;
                            </li>
                            <li>
                                Browsing history, activity history, date of birth, gender, specific behavioral
                                cookies, device information (such as IP address and device type), any national
                                identifiers (e.g., driver's license or national ID details), and publicly available
                                information (e.g., social media profiles or news) necessary to conduct relevant
                                checks.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Notice Of Disclosure of Personal Data:</h5>
                        <p class="text-dark">
                            We, as the data controller, may disclose your personal data to third-party service providers
                            who assist us in operating Deben and providing our services in accordance with applicable
                            data protection laws and regulations. We reserve the right to disclose your personal data in
                            the following circumstances:
                        </p>
                        <ul class="text-muted vstack gap-2">
                            <li>
                                To banks and other third parties with whom we have commercial relationships;
                            </li>
                            <li>
                                To comply with legal requirements, including orders, instructions, or requests from
                                courts or regulatory authorities; and/or
                            </li>
                            <li>
                                advertisers and/or for marketing purposes. For marketing purposes that involve
                                personal identifiable information (PII), individuals involved will be informed, and
                                their consent shall be acquired prior to any marketing/advertising engagement.
                            </li>
                            <li>
                                We undertake reasonable measures to ensure the protection of your personal data by
                                requiring third-party service providers to maintain the confidentiality of your personal
                                data and to only use it for the purposes for which we have shared it with them.
                            </li>
                        </ul>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Security of Your Information:</h5>
                        <p class="text-muted">
                            We are committed to protecting the security of your personal information. We take all
                            reasonable steps to protect your personal information from misuse, loss, unauthorized
                            access, disclosure, disruption, modification, and destruction. These steps include:
                            Implementing firewalls and other security measures to protect our systems from unauthorized
                            access;
                        </p>
                        <p class="text-muted">
                            Requiring employees, contractors, and agents to keep personal information confidential;
                        </p>
                        <p class="text-muted">
                            Periodically reviewing our information collection, storage, and processing practices; and
                        </p>
                        <p class="text-muted">
                            Limiting access to personal information to those who need it to do their job.
                        </p>
                        <p class="text-muted">
                            However, please be aware that there is always some risk when transmitting information over
                            the internet. Therefore, to the extent permitted by law, we cannot guarantee the security of
                            your personal information transmitted over the internet. If you suspect any misuse, loss, or
                            unauthorized access to your personal information, please notify us immediately.
                        </p>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Data Storage and Retention:</h5>
                        <p class="text-muted">
                            We store the data you provide to us on our servers. These servers are located in third-party
                            data centers within the Kingdom of Saudi Arabia. We take all reasonable measures to secure
                            and keep your personal data confidential during storage and retrieval.
                        </p>
                        <p class="text-muted">
                            We will retain your personal data for as long as necessary to fulfill the purposes set out
                            in this Privacy Policy, or as required by law. We will determine the retention period based
                            on our need to collect personal data and will only retain it for the shortest feasible
                            duration to achieve the purpose of collection.
                        </p>
                        <p class="text-muted">
                            If we no longer require your personal data, we will take reasonable steps to securely delete
                            it or render it anonymous.
                        </p>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">Amendments and Modifications to This Privacy
                            Policy:</h5>
                        <p class="text-muted">
                            We may amend, update, or modify this Privacy Policy at any time. Any changes will be
                            effective immediately upon posting on our website or notification to you. We encourage you
                            to review this Privacy Policy periodically to ensure that you understand the terms that
                            apply to your use of our services.
                        </p>
                        <p class="text-muted">
                            Your continued use of our services after any changes to this Privacy Policy constitutes your
                            acceptance of those changes. If you do not agree to any revised terms, you must immediately
                            discontinue your use of our services.
                        </p>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">
                            Contacting Us:
                        </h5>
                        <p class="text-dark">
                            We conduct regular reviews of our compliance with this Privacy Policy. If you have any
                            questions or concerns about how we process your personal data, or if you wish to file a
                            complaint, please reach out to us using the contact details provided below:
                        </p>
                        <p class="text-muted">
                            We will endeavor to respond to your inquiry or complaint as soon as possible and take
                            appropriate measures to address any concerns you may have. If we cannot resolve your
                            concern, you may have the right to lodge a complaint with the relevant supervisory
                            authority.
                        </p>
                    </div>
                    <div>
                        <h5 class="text-decoration-underline fw-bold">
                            Contact Information:
                        </h5>
                        <p class="text-dark">
                            Email: info&#64;deben.io
                        </p>
                        <p class="text-dark">
                            Number: +966 50 935 8075
                        </p>
                        <p class="text-dark">
                            Address: Ar Rabie Dist. Building No. 8479 Al Mashaf St., Riyadh, Kingdom of Saudi Arabia
                        </p>
                    </div>
                </div>
                <div class="row p-3">
                </div>
            </div>
        </div><!--end col-->
    </div><!--end row-->

    <div class="row">
        <div class="col-lg-12">
            <div class="text-center">
                <p class="mb-0 text-muted">&copy; {{year}} {{ 'COMMON.DEBEN' | translate }} {{
                    'COMMON.All_RIGHTS_RESERVED' | translate }}
                    <a routerLink="/terms-and-conditions" target=" _blank" rel="noopener"
                        class="text-primary text-decoration-underline fs-14 fw-medium">
                        {{'COMMON.TERMS_OF_USE' | translate}}
                    </a>,
                    <a routerLink="/privacy-policy" target="_blank" rel="noopener"
                        class="text-primary text-decoration-underline fs-14 fw-medium">
                        {{'COMMON.PRIVACY_POILICY' | translate}}
                    </a>
                </p>
                <p class="mb-0 text-muted">
                    {{'COMMON.PROTECTED_BY' | translate}} {{'COMMON.RECAPTCHA' | translate}}
                    <span>{{'COMMON.TERMS_APPLY_AR' | translate}}</span>
                    <a href="https://policies.google.com/privacy" target="_blank" rel="noopener"
                        class="text-muted text-decoration-underline fs-14 fw-medium">
                        {{'COMMON.GOOGLE_PRIVACY_POILICY' | translate}}
                    </a> <span> {{'COMMON.AND' | translate}} </span>
                    <a href="https://policies.google.com/terms" target="_blank" rel="noopener"
                        class="text-muted text-decoration-underline fs-14 fw-medium">
                        {{'COMMON.TERMS_OF_SERVICE' | translate}}
                    </a>
                    <span>{{'COMMON.TERMS_APPLY_EN' | translate}}</span>
                </p>
            </div>
        </div>
    </div>
</div>